<template>
  <button v-if="accessToken" class="btn btn-secondary" @click="revokeToken"><i class="fas fa-sign-out-alt mr-1"></i>Tancar accés</button>
  <button v-else class="btn btn-primary" @click="getToken" :disabled="loading.autorizacion"><i class="fas fa-fw mr-1" :class="loading.autorizacion ? 'fa-spinner fa-spin' : 'fa-key'"></i>Autoritzar accés</button>
</template>
      
<script>
export default {
  name: "GIS",
  props: ["scope", "parentAccessToken"],
  data() {
    return {
      loading: {
        autorizacion: false,
      },
      authorized: false,
      gsiClientURL: "https://accounts.google.com/gsi/client",
      client: null,
      accessToken: null,
    };
  },
  created() {
    this.$loadScript(this.gsiClientURL)
      .then(() => {
        this.initClient();
      })
      .catch((e) => {
        this.$toast.open({ type: "error", position: "top", message: "No es pot connectar amb Google ara mateix. Si us plau, prova més endavant.", duration: 0 });
      });

    if (this.parentAccessToken) {
      fetch(`https://oauth2.googleapis.com/tokeninfo?${new URLSearchParams({ "access_token": this.parentAccessToken })}`)
        .then(response => {
          if (response.status == 200) {
            this.accessToken = this.parentAccessToken;
          } else {
            this.accessToken = null;

            this.$emit("cambiarAutorizacion", null);
          }
        })
    }
  },
  destroyed() {
    this.$toast.clear();
    this.$unloadScript(this.gsiClientURL);
  },
  methods: {
    initClient() {
      this.client = google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: this.scope,
        callback: (tokenResponse) => {
          this.accessToken = tokenResponse.access_token;
        },
      });
    },
    getToken() {
      this.client.requestAccessToken();
    },
    revokeToken() {
      google.accounts.oauth2.revoke(this.accessToken, () => this.accessToken = null);
    },
  },
  watch: {
    parentAccessToken(value) {
      if (value) return;

      this.accessToken = null;
    },
    accessToken(value) {
      this.$emit("cambiarAutorizacion", value);
    },
  },
};
</script>